export const VALID_INSTRUCTIONAL_AREA_KEYS = new Set(["51", "52", "53", "54", "55", "56", "57"]);
